import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  ChartData,
  Legend,
  ChartDataset
} from 'chart.js'
import {orderBy} from 'lodash'
import {useMemo} from 'react'
import {Bar} from 'react-chartjs-2'
import {useTranslation} from 'react-i18next'

import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../consts'
import {useDowntimeBarChartOptions} from '../hooks'
import {type StoppagesFailureTypesResponse} from '../types'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

type StoppagesFailureChartProps = {
  data: StoppagesFailureTypesResponse | undefined
}

export const StoppagesFailureChart = ({data}: StoppagesFailureChartProps) => {
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)

  const chartData = useMemo<ChartData<'bar'>>(() => {
    const datasets: ChartDataset<'bar'>[] = [
      {
        label: t('stoppagesFailureChart.failureType.circumstance'),
        data: [],
        backgroundColor: customThemeConstants().palette.accent1,
        barThickness: 32
      },
      {
        label: t('stoppagesFailureChart.failureType.incident'),
        data: [],
        backgroundColor: customThemeConstants().palette.accent2,
        barThickness: 32
      },
      {
        label: t('stoppagesFailureChart.failureType.scheduled'),
        data: [],
        backgroundColor: customThemeConstants().palette.accent5,
        barThickness: 32
      }
    ]
    const columns: number[] = []
    orderBy(data?.failureTypes, 'year').forEach((failureType) => {
      columns.push(failureType.year)
      datasets[0].data.push(failureType.failureTypeCircumstanceNumber)
      datasets[1].data.push(failureType.failureTypeIncidentNumber)
      datasets[2].data.push(failureType.failureTypePlannedNumber)
    })

    return {
      labels: columns,
      datasets
    }
  }, [data, t])

  const chartOptions = useDowntimeBarChartOptions()

  return <Bar options={chartOptions} data={chartData} data-test-id="stoppages-failure-chart" />
}
